/* eslint-disable */
import ReportDetailPlayerList from './report-detail-player.list';

export default {
  // TODO: Temporarily use auto-render reports
  // list: ReportDetailPlayerList,
};
